// Interactive-duel cell overlays: the green reachable-cell highlight shown
// while choosing a move, and the red highlight on legal attack targets.
export const MOVE_CELL_COLOR = 0x3ad16a;
export const MOVE_CELL_ALPHA = 0.26;
export const MOVE_CELL_BORDER_COLOR = 0x6bf09a;

export const TARGET_CELL_COLOR = 0xe7553c;
export const TARGET_CELL_ALPHA = 0.34;
export const TARGET_CELL_BORDER_COLOR = 0xff8e7a;

export const OVERLAY_BORDER_PX = 2;
export const OVERLAY_BORDER_ALPHA = 0.9;
